export const MOMENT_TIME_FORMAT = 'HH:mm:ss';
export const MOMENT_TIME_DISPLAY_FORMAT = 'hh:mm A';
export const MOMENT_TIME_DISPLAY_FORMAT_24_HRS = 'HH:mm';
export const MOMENT_DATE_FORMAT = 'YYYY-MM-DD';
export const MOMENT_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export const MOMENT_DATE_DISPLAY_FORMAT = 'MMM-DD-YYYY';
export const MOMENT_WEEKDAY_FORMAT = 'dddd';
export const MOMENT_DISPLAY_FORMAT = 'MMMM DD, YYYY hh:mm A';
export const INSTRUCTOR_TIMETABLE = 'INSTRUCTOR_TIMETABLE';
export const SET_TIMETABLE = 'SET_TIMETABLE';
export const ROOM_TIMETABLE = 'ROOM_TIMETABLE';
export const NEXT_WEEK = 'Next Week';
export const PREV_WEEK = 'Prev Week';
export const BUSINESS_SCHOOL_ID = 1;
export const KENDO_TIME_PICKER_FORMAT = 'MMM-dd-yyyy';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const MOMENT_DATE_FULL_FORMAT = 'MMMM D, YYYY';
export const MOMENT_DATE_SIMPLE_FORMAT = 'MMM DD'